// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"b3bfaf74","787":"c7d1202c"}[chunkId] + ".chunk.js";
};